<template>
  <div
    :class="{
      'product-format': true,
      'on-offer': product._source.Promotion,
    }"
  >
    <b-row>
      <b-col
        cols="12"
        md="4"
        lg="6"
        v-if="
          product._source.DutyType === 'DP' &&
          product._source.StockStatus !== 'Enquire'
        "
        class="align-self-center product-format-detail"
      >
        <span v-if="product._source.DP_Price > 0">
          {{ product._source.DP_Price | currency }}

          ({{
            product._source.StockPackage === "bottle"
              ? product._source.BottleSize
              : product._source.CaseSize
          }})
          <span
            v-if="
              product._source.Promotion &&
              product._source.MixedCaseType === '' &&
              product._source.DP_Price_Old !== null
            "
            class="was-price"
            >(Was {{ product._source.DP_Price_Old | currency }})</span
          >
        </span>
        <span v-else>
          {{ product._source.RangeFrom | currency }} -
          {{ product._source.RangeTo | currency }} ({{
            product._source.StockPackage === "bottle"
              ? product._source.BottleSize
              : product._source.CaseSize
          }})
        </span>

        <b-badge
          v-if="
            product._source.StatusLabels['Sold Out'] ||
            product._source.StockLevel === 0
          "
          class="float-none"
          variant="danger"
          >Sold Out</b-badge
        >&nbsp;
        <b-badge
          v-if="
            product._source.StatusLabels['Low Stock'] &&
            !product._source.StatusLabels['Sold Out'] &&
            product._source.StockLevel > 0
          "
          class="float-none"
          variant="warning"
          >Low Stock</b-badge
        >&nbsp;
        <b-badge
          v-if="product._source.StatusLabels['On Allocation']"
          class="float-none"
          variant="warning"
          >On Allocation</b-badge
        >&nbsp;
        <b-badge
          v-if="product._source.StatusLabels['Over Subscribed']"
          class="float-none"
          variant="warning"
          >Over Subscribed</b-badge
        >
      </b-col>
      <b-col
        cols="12"
        md="4"
        lg="6"
        v-if="
          product._source.DutyType === 'IB' &&
          (product._source.IB_CasePrice ||
            product._source.StockStatus === 'Pre-Order' ||
            product._source.StockStatus === 'Apply')
        "
        class="align-self-center product-format-detail"
      >
        <span v-if="product._source.IB_CasePrice > 0">
          {{ product._source.IB_CasePrice | currency }}
          ({{ product._source.CaseSize }})
          <span
            v-if="
              product._source.Promotion &&
              product._source.MixedCaseType === '' &&
              product._source.IB_CasePrice_Old !== null
            "
            class="was-price"
            >(Was {{ product._source.IB_CasePrice_Old | currency }})</span
          >
        </span>
        <span v-else-if="product._source.RangeFrom && product._source.RangeTo">
          {{ product._source.RangeFrom | currency }} -
          {{ product._source.RangeTo | currency }} ({{
            product._source.CaseSize
          }})
        </span>
        <span v-else>Price TBA ({{ product._source.CaseSize }}) </span>
        <b-badge
          v-if="
            product._source.StatusLabels['Sold Out'] ||
            product._source.StockLevel === 0
          "
          class="float-none"
          variant="danger"
          >Sold Out</b-badge
        >&nbsp;
        <b-badge
          v-if="
            product._source.StatusLabels['Low Stock'] &&
            !product._source.StatusLabels['Sold Out'] &&
            product._source.StockLevel > 0
          "
          class="float-none"
          variant="warning"
          >Low Stock</b-badge
        >&nbsp;
        <b-badge
          v-if="product._source.StatusLabels['On Allocation']"
          class="float-none"
          variant="warning"
          >On Allocation</b-badge
        >&nbsp;
        <b-badge
          v-if="product._source.StatusLabels['Over Subscribed']"
          class="float-none"
          variant="warning"
          >Over Subscribed</b-badge
        >
      </b-col>
      <b-col
        cols="12"
        md="8"
        lg="6"
        v-if="
          product._source.StockStatus === 'Stock' ||
          product._source.StockStatus === 'Apply' ||
          product._source.StockStatus === 'Pre-Order'
        "
        class="align-self-center"
      >
        <div
          class="product-add-to-cart text-md-right"
          v-if="product._source.StockLevel > 0"
        >
          <form
            class="cart"
            method="post"
            enctype="multipart/form-data"
            @submit.prevent="
              addToBasket(product._source, product._source._add_qty)
            "
          >
            <div class="quantity float-left float-md-none">
              <label
                class="screen-reader-text"
                :for="'quantity_' + product._source.WCID"
                >{{ product._source.ItemDescription[0] }} quantity</label
              >
              <quantity instant v-model="product._source._add_qty" />
            </div>

            <button
              type="submit"
              name="add-to-cart"
              :value="product._source.WCID"
              :disabled="adding"
              v-if="product._source.StockStatus === 'Stock'"
              class="btn btn-primary btn-rounded float-right float-md-none"
            >
              Add

              <svg
                class="bi spin"
                :class="{ 'd-none': !adding }"
                width="1rem"
                height="1rem"
                fill="currentColor"
              >
                <use
                  xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#arrow-repeat"
                />
              </svg>

              <svg
                class="bi"
                :class="{ 'd-none': adding }"
                width="1rem"
                height="1rem"
                fill="currentColor"
              >
                <use
                  xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#arrow-right-circle"
                />
              </svg>
            </button>

            <button
              type="submit"
              name="add-to-cart"
              v-if="product._source.StockStatus === 'Apply'"
              :value="product._source.WCID"
              :disabled="adding"
              class="btn btn-primary btn-rounded float-right float-md-none"
            >
              Apply

              <svg
                class="bi spin"
                :class="{ 'd-none': !adding }"
                width="1rem"
                height="1rem"
                fill="currentColor"
              >
                <use
                  xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#arrow-repeat"
                />
              </svg>

              <svg
                class="bi"
                :class="{ 'd-none': adding }"
                width="1rem"
                height="1rem"
                fill="currentColor"
              >
                <use
                  xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#arrow-right-circle"
                />
              </svg>
            </button>

            <button
              type="submit"
              name="add-to-cart"
              v-if="product._source.StockStatus === 'Pre-Order'"
              :value="product._source.WCID"
              :disabled="adding"
              class="btn btn-primary btn-rounded float-right float-md-none"
            >
              Pre-Order

              <svg
                class="bi spin"
                :class="{ 'd-none': !adding }"
                width="1rem"
                height="1rem"
                fill="currentColor"
              >
                <use
                  xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#arrow-repeat"
                />
              </svg>

              <svg
                class="bi"
                :class="{ 'd-none': adding }"
                width="1rem"
                height="1rem"
                fill="currentColor"
              >
                <use
                  xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#arrow-right-circle"
                />
              </svg>
            </button>
          </form>
        </div>
      </b-col>
      <b-col
        v-if="product._source.StockStatus === 'Enquire'"
        class="text-right"
      >
        <b-button variant="primary" rounded @click="showEnquire(product)"
          >Enquire for availability</b-button
        >
        <enquire-modal :product="product"></enquire-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Quantity from "@/components/Quantity";
import EnquireModal from "@/components/EnquireModal";

export default {
  components: {
    Quantity,
    EnquireModal,
  },
  props: {
    product: {
      type: [Object, Boolean],
      default: false,
    },
  },
  data() {
    return {
      adding: false,
    };
  },
  methods: {
    showEnquire(product) {
      this.$bvModal.show("enquire-modal-" + product._id);
    },
    addToBasket(product, quantity) {
      this.adding = true;
      return this.$store
        .dispatch("basket/add_item", {
          product_id: product.WCID,
          product_title: product.ItemDescription[0],
          quantity,
        })
        .finally(() => {
          this.adding = false;
        });
    },
  },
};
</script>